export const queryKey = {
  ORDER_LIST: "order_list",
  ORDER_DETAIL: "order_detail",
  ORDER_FEEDBACK_NEW: "order_feedback_new",
  SKILL_LIST: "skill_list",
  BANNER_LIST: "banner_list",
  RESORT_LIST: "resort_list",
  COACH_LIST: "coach_list",
  COACH_INFO: "coach_info",
  COACH_SCHEDULE: "coach_schedule",
  PROFILE: "profile",
  LANGUAGE: "language",
  FAQ_LIST: "faq_list",
  FAQ_CATEGORY_LIST: "faq_cateogory_list",
  NEWS_LIST: "news_list",
  NEWS_DETAIL: "news_detail",
  NEWS_CATEGORY_LIST: "news_cateogory_list",
  SESSION_LIST: "session_list",
  SESSION_SCHEDULE: "session_schedule",
  PAYMENT_METHOD_LIST: "payment_method_list",
  PHONE_CODE: "phone_code",
  USER_LEVEL_LIST: "user_level_list",
  CART: "cart",
  CHAT_LIST: "chat_list",
  REFUND_POLICY: "refund_policy",
  USER_ORDER_DETAIL: "user_order_detail",
  REFUND_DATA: "refund_data",
  CART_STATUS: "cart_status",
  COUPON_CHECK: "coupon_check",
};
